import React from "react";
import { Navigate, useNavigate } from "react-router-dom";

import { RoutePath } from "../../../routes/route-path";

import { AppDispatch } from "../../../slices/store";
import { logoutUser } from "../../../slices/thunk";
import { useAppDispatch, useAppSelector } from "../../../slices/hook";

import { getAuthState } from "../../../slices/auth/login/reducer";
import { getLayoutState } from "../../../slices/layouts/reducer";

import NoneAuthLayoutSwitch from "../none-auth-layout-switch";
import LoadingComponent from "../../../common/components/loader";

const AdminLogout: React.FC = () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useAppDispatch();
  const { loading, loggedInuser } = useAppSelector(getAuthState);

  React.useEffect(() => {
    dispatch(logoutUser());
  }, []);

  React.useEffect(() => {
    if (!loggedInuser?.id) {
      navigate(RoutePath.Admin_Login_page);
    }
  }, [loggedInuser]);

  const { layoutNoneAuthTheme } = useAppSelector(getLayoutState);

  return (
    <React.Fragment>
      <NoneAuthLayoutSwitch>
        <LoadingComponent />
      </NoneAuthLayoutSwitch>
    </React.Fragment>
  );
};

export default AdminLogout;
